import { render, staticRenderFns } from "./SiteAdminsEdit.vue?vue&type=template&id=c915c866&scoped=true&"
import script from "./SiteAdminsEdit.vue?vue&type=script&lang=js&"
export * from "./SiteAdminsEdit.vue?vue&type=script&lang=js&"
import style0 from "./SiteAdminsEdit.vue?vue&type=style&index=0&id=c915c866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c915c866",
  null
  
)

export default component.exports